export class ModelClientError extends Error {
  canRetry: boolean = false
  tokenLimitReached: boolean = false

  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args)
    this.name = 'ModelClientError'
  }
}

export class TimeoutError extends ModelClientError {
  constructor(...args: ConstructorParameters<typeof Error>) {
    super(...args)
    this.name = 'TimeoutError'
  }
}
export const TokenLimitReachedResponseErrorDescription = 'The conversation token limit has been reached. '
export class TokenLimitReachedResponseError extends ModelClientError {
  constructor() {
    super(TokenLimitReachedResponseErrorDescription)
    this.name = 'TokenLimitReachedResponseError'
    this.tokenLimitReached = true
  }
}

export class CompletionTokensLimitReachedResponseError extends ModelClientError {
  constructor() {
    super(
      'The completion tokens limit has been reached for this response. Please increase the max completion tokens parameter or try a different prompt.',
    )
    this.name = 'CompletionTokensLimitReachedResponseError'
    this.canRetry = true
  }
}

const tooManyRequestsDefaultError = 'Rate limited, please try again later.'
const tooManyRequestsErrorPrefixForRetry = 'Rate limited, please try again in '

export function tooManyRequestsErrorMessage(retryAfter?: string | null) {
  return retryAfter ? `${tooManyRequestsErrorPrefixForRetry}${retryAfter} seconds.` : tooManyRequestsDefaultError
}

export function isDefaultTooManyRequestsErrorMessage(message: string | null | undefined) {
  if (typeof message !== 'string') return false
  return message === tooManyRequestsDefaultError || message.startsWith(tooManyRequestsErrorPrefixForRetry)
}

export class TooManyRequestsError extends ModelClientError {
  constructor({
    message,
    retryAfter,
  }: {message?: string | null | undefined; retryAfter?: string | null | undefined} = {}) {
    if (typeof message !== 'string' || message.trim().length < 1) {
      message = tooManyRequestsErrorMessage(retryAfter)
    }
    super(message)
    this.canRetry = true
    this.name = 'TooManyRequestsError'
  }
}

// Analytics events
export const PlaygroundChatRequestSent = 'github_models.playground.chat_request.sent'
export const PlaygroundChatRateLimited = 'github_models.playground.chat_request.rate_limited'
export const PlaygroundChatRequestStreamingStarted = 'github_models.playground.chat_request.streaming_started'
export const PlaygroundChatRequestStreamingCompleted = 'github_models.playground.chat_request.streaming_completed'
export const PlaygroundChatSuggestion = 'github_models.playground.chat_suggestion'
export const GettingStartedButtonClicked = 'github_models.getting_started.clicked'
export const RunCodespaceButtonClicked = 'github_models.run_codespace.clicked'
export const ImproveSystemPromptClicked = 'github_models.improve_system_prompt.clicked'
export const GenerateSystemPromptClicked = 'github_models.generate_system_prompt.clicked'
export const UseImprovedSystemPromptClicked = 'github_models.use_improved_system_prompt.clicked'
export const CancelImprovedSystemPromptClicked = 'github_models.cancel_improved_system_prompt.clicked'
export const ImproveUserPromptClicked = 'github_models.improve_user_prompt.clicked'
export const GenerateUserPromptClicked = 'github_models.generate_user_prompt.clicked'
export const UseImprovedUserPromptClicked = 'github_models.use_improved_user_prompt.clicked'
export const CancelImprovedUserPromptClicked = 'github_models.cancel_improved_user_prompt.clicked'

// Codespaces
export const templateRepositoryNwo = 'github/codespaces-models'
